import JobListingMutations from "./jobListing/jobListing.mutation";
import JobListingQueries from "./jobListing/jobListing.query";

const JobListingServices = {
  ...JobListingQueries,
  ...JobListingMutations,
};

export default JobListingServices;
